<template>
  <v-main>
    <AppBar title="솔루션 샘플 페이지" />
    <component :is="tarComponent" />
  </v-main>
</template>

<script>
export default {
  components: {
  },
  mixins: [],
  props: {},
  data: () => ({
    targetComponent: null
  }),
  computed: {
    folder () {
      return this.$route.params.folder
    },
    file () {
      return this.$route.params.file
    }
  },
  watch: {},
  created () {
    let componentName = this.file
    this.$options.components[componentName] = () => import(`@/page/solution/${this.folder}/${this.file}.vue`)
    this.targetComponent = componentName
  },
  mounted () {},
  methods:{}
}
</script>

<style lang="scss" scoped>
</style>
